import React, { useCallback, useMemo } from 'react'
import { usePanelPatientUid } from '../../dashboard/panelContext'
import { CardFooter, FieldRow, FieldSection, LabeledText } from '../fieldPrimitives'
import { EMERGENCY_CONTACT_SCHEMA } from './patientRecordSchema'
import { makeFieldSetter, useCardAutosave } from './useCardAutosave'
import { usePatientRecord } from './usePatientRecord'
import { useUpdatePatientRecord } from './useUpdatePatientRecord'

type EmergencyContactValues = { name: string; phone: string }

const EmergencyContactPanel = () => {
  const uid = usePanelPatientUid()
  const { loading, patient } = usePatientRecord(uid)
  const update = useUpdatePatientRecord(uid)

  const initial = useMemo<EmergencyContactValues>(
    () => ({
      name: patient?.emergencyContact?.name ?? '',
      phone: patient?.emergencyContact?.phone ?? '',
    }),
    [patient?.emergencyContact?.name, patient?.emergencyContact?.phone]
  )

  // Both fields go every time — `patientEmergencyContact.upsertOne` merges nothing (README/DECISIONS).
  const save = useCallback((next: EmergencyContactValues) => update({ emergencyContact: next }, undefined), [update])

  const { values, setValues, error, status } = useCardAutosave(initial, EMERGENCY_CONTACT_SCHEMA, save)
  const set = makeFieldSetter(setValues)

  return (
    <FieldSection>
      <FieldRow columns={2}>
        <LabeledText label="Emergency contact name" value={values.name} onChange={set('name')} />
        <LabeledText label="Emergency contact phone" value={values.phone} onChange={set('phone')} />
      </FieldRow>
      <CardFooter loading={loading} status={status} error={error} />
    </FieldSection>
  )
}

export default EmergencyContactPanel
